export default __webpack_public_path__ + "static/media/mark.ee229109.svg";